// Copyright (c) 2016 Deere & Company

import SearchFilters from '../../../shared/state/search-filters';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetFilters = state => SearchFilters.update(state, {
    $set: getDefaultState().searchFilters
});

const updateListFilterBy = (state, action) =>
    SearchFilters.update(state, {
        filterBy: {
            $set: action.filterBy
        }
    });

const updateListSortBy = (state, action) =>
    SearchFilters.update(state, {
        sortBy: {
            $set: action.sortBy
        }
    });

const updateListSortDirection = (state, action) =>
    SearchFilters.update(state, {
        sortDirection: {
            $set: action.sortDirection
        }
    });

export default (state = getDefaultState().searchFilters, action) => {

    const actionTypes = {
        [actions.RESET_OPEN_PIP_PRODUCTS_FILTERS]: resetFilters,
        [actions.UPDATE_OPEN_PIP_PRODUCTS_FILTER_BY]: updateListFilterBy,
        [actions.UPDATE_OPEN_PIP_PRODUCTS_SORT_BY]: updateListSortBy,
        [actions.UPDATE_OPEN_PIP_PRODUCTS_SORT_DIRECTION]: updateListSortDirection
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/open-pips/reducers/search-filters.js